export const landingPagesQuery = `
*[_type == 'page' && slug.current == $slug]{
  _id, title, metaDescription, slug, name, category, country, _updatedAt,
  segments[]->{ ..., 
    block{ ..., 
      content[]{ ..., 
        markDefs[]{ ..., 'colorHex': {...}->.color.hex }
      }, 
      heading[]{ ..., 
        markDefs[]{ ..., 'colorHex': {...}->.color.hex }
      },
      badges[]{title, 'colorHex': color->{...}.color.hex},
    },
    heading[]{ ..., 
      markDefs[]{ ..., 'colorHex': {...}->.color.hex }
    },
    lineColor->,
    blocks[]{ ...,
      content[]{ ...,
        markDefs[]{ ..., 'colorHex': {...}->.color.hex }
      },
      heading[]{ ..., 
        markDefs[]{ ..., 'colorHex': {...}->.color.hex }
      },
      badges[]{title, 'colorHex': color->{...}.color.hex},
    },
    'bgColorHex': bgColor->.color.hex,
    'bgFilterFromColorHex': bgFilterFromColor->.color.hex,
    'bgFilterToColorHex': bgFilterToColor->.color.hex,
  }
}
`;

const postFields = `
  _id,
  name,
  title,
  excerpt,
  metaTitle,
  metaDescription,
  date,
  tags,
  coverImage,
  "slug": slug.current,
  "author": author->{name, picture},
`;

export const blogQuery = `
*[_type == "post"] | order(date desc, _updatedAt desc) {
  ${postFields}
}`;

export const postQuery = `
{
  "post": *[_type == "post" && slug.current == $slug] | order(_updatedAt desc) [0] {
    body,
    ${postFields}
  },
  "morePosts": *[_type == "post" && slug.current != $slug] | order(date desc, _updatedAt desc) [0...2] {
    body,
    ${postFields}
  }
}`;

export const featureSlugsQuery = `
*[_type == "page" && category == "features" && defined(slug.current)][].slug.current
`;

export const countrySlugsQuery = `
*[_type == "page" && category == "countries" && defined(slug.current)][].slug.current
`;

export const postSlugsQuery = `
*[_type == "post" && defined(slug.current)][].slug.current
`;

export const postBySlugQuery = `
*[_type == "post" && slug.current == $slug][0] {
  ${postFields}
}
`;

export const siteMapQuery = `
*[(_type == "page" || _type == "post") && defined(slug.current) && !(_id in path("drafts.**"))]
 | order(_updatedAt desc) | order(category desc) | order(_type asc) 
 {"slug": slug.current, "lastmod": _updatedAt}
`;
